import React from 'react';

import PropTypes from 'prop-types';

import { Script } from '~/techstyle-shared/react-marketing';

export default function KlarnaPlacement(props) {
  const {
    id,
    locale,
    amount,
    type,
    scriptSrc,
    environment,
    clientId,
    instanceName,
  } = props;

  return (
    <>
      <Script
        async
        globalScriptKey="klarna-widget"
        shouldPersistInDOM
        skipServerRender
        data-environment={environment}
        src={scriptSrc}
        data-client-id={clientId}
        data-client-instance-name={instanceName}
      />
      <klarna-placement
        id={id}
        data-key={type}
        data-locale={locale}
        data-purchase-amount={amount}
      />
    </>
  );
}

KlarnaPlacement.propTypes = {
  amount: PropTypes.number,
  clientId: PropTypes.string.isRequired,
  environment: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  instanceName: PropTypes.string,
  locale: PropTypes.string.isRequired,
  scriptSrc: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
